import React from 'react';
import { ShoppingCart, Clock, User, X, Play } from 'lucide-react';
import { formatMoney } from '../../utils/formatters';
import './PendingOrdersBar.css';

// Función para calcular tiempo transcurrido
const getTimeAgo = (timestamp) => {
  const now = Date.now();
  const diff = now - timestamp;
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);

  if (minutes < 1) return 'Ahora';
  if (minutes < 60) return `${minutes}min`;
  if (hours < 24) return `${hours}h`;
  return `${Math.floor(hours / 24)}d`;
};

// Función para calcular el total del carrito
const calcularTotal = (cart) => {
  if (!cart || cart.length === 0) return 0;
  return cart.reduce((total, item) => {
    return total + (item.precio_unitario * item.cantidad);
  }, 0);
};

const PendingOrdersBar = ({ pedidos, onRetomar, onEliminar }) => {
  if (!pedidos || pedidos.length === 0) {
    return null;
  }

  return (
    <div className="pending-orders-bar">
      <div className="pending-orders-header">
        <ShoppingCart size={16} />
        <span>Pedidos en espera ({pedidos.length})</span>
      </div>

      <div className="pending-orders-carousel">
        {[...pedidos].sort((a, b) => b.timestamp - a.timestamp).map((pedido) => {
          const total = pedido.total || calcularTotal(pedido.cart);
          const itemCount = pedido.cart?.length || 0;
          const clienteName = pedido.cliente?.nombre || pedido.cliente?.nombre_comercial || 'Sin cliente';

          return (
            <div
              key={pedido.id}
              className="pending-order-card"
              onClick={() => onRetomar(pedido.id)}
            >
              <div className="order-card-content">
                <div className="order-client">
                  <User size={12} />
                  <span>{clienteName}</span>
                </div>

                <div className="order-details">
                  <span className="order-items">{itemCount} productos</span>
                  <span className="order-total">{formatMoney(total)}</span>
                </div>

                <div className="order-time">
                  <Clock size={10} />
                  <span>{getTimeAgo(pedido.timestamp)}</span>
                </div>

                {pedido.deliveryType && (
                  <div className={`order-delivery-type ${pedido.deliveryType}`}>
                    {pedido.deliveryType === 'domicilio' ? 'Dom.' : 'Pick'}
                  </div>
                )}
              </div>

              <div className="order-actions">
                <button
                  className="order-action-btn retomar"
                  onClick={(e) => {
                    e.stopPropagation();
                    onRetomar(pedido.id);
                  }}
                  title="Retomar pedido"
                >
                  <Play size={14} />
                </button>
                <button
                  className="order-action-btn eliminar"
                  onClick={(e) => {
                    e.stopPropagation();
                    onEliminar(pedido.id);
                  }}
                  title="Eliminar pedido"
                >
                  <X size={14} />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PendingOrdersBar;
